export default __webpack_public_path__ + "static/media/tdex-no-color-mini.8b4e2bb0.svg";